import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { AdminReport } from 'app/admin/interface/reports/admin-report.interface';
import { ReportExportExcel } from 'app/admin/interface/reports/export-excel/report-export-excel.interface';
import { SpinnerService } from 'app/shared/spinner/spinner.service';
import { UserMessagesService } from 'app/shared/user-messages/user-messages.service';
import { PasswordProtectionData } from '../password-protection/password-protection-data.interface';
import { PasswordProtectionComponent } from '../password-protection/password-protection.component';
import { PasswordProtectionService } from '../password-protection/password-protection.service';

@Component({
  selector: 'app-export-to-excel',
  templateUrl: './export-to-excel.component.html',
  styleUrls: ['./export-to-excel.component.css']
})
export class ExportToExcelComponent implements OnInit {

  @Input() data: ReportExportExcel<AdminReport>;
  @Input() fullUrl: string;
  @Input() filename: string;
  @Input() isPasswordRequired: boolean;
  @ViewChild("exportedFileLink") private _exportedFileLink: ElementRef;
  private _exporting: boolean = false;
  selectedPassword: string;


  constructor(
    private _spinner: SpinnerService,
    private _userMessages: UserMessagesService,
    private _httpClient: HttpClient,
    private _passwordProtectionDialog: MatDialog,
    private _passwordProtectionService: PasswordProtectionService
  ) {
  }

  ngOnInit() {
  }

  export(): void {
    if (this._exporting) return;

    this._userMessages.clearSnackBarMessage();

    if (this.isPasswordRequired) {
      this._showPasswordProtectionDialog();
    }
    else {
      this._exportToExcel();
    }
  }

  private _getDialogConfig(): MatDialogConfig {
    const config = new MatDialogConfig<PasswordProtectionData>();
    config.data = {
      minLength: 4,
      maxLength: 20
    };
    config.hasBackdrop = true;
    config.closeOnNavigation = true;
    config.disableClose = true;
    config.width = "600px";

    return config;
  }

  private _showPasswordProtectionDialog(): void {
    const config = this._getDialogConfig();
    const dialog = this._passwordProtectionDialog.open(PasswordProtectionComponent, config);
    const dialogSubscrption = this._passwordProtectionService.confirm$.subscribe((password: string) => {
      if (password) {
        this.data["password"] = password;
        this.selectedPassword = password;
        this._exportToExcel();
      }
      else if (password === null) {
        this.selectedPassword = null;
        const message = "לא נבחרה סיסמה. ייצוא הנתונים בוטל";
        this._userMessages.showSnackBarErrorMessage(message, 3000);
      }

      dialogSubscrption.unsubscribe();
      dialog.close();
    });
  }

  private _exportToExcel(): void {
    if (this.isPasswordRequired && !this.data["password"]) {
      console.error("Mandatory password is missing");
      return;
    }

    const headers = new HttpHeaders().set("Accept", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    this._exporting = true;
    this._spinner.showSpinner();
    const subscription = this._httpClient.post(this.fullUrl, this.data, { headers, responseType: "blob" })
      .subscribe((response: Blob) => {
        this._spinner.hideSpinner();
        this._exporting = false;
        this._onBlobReceived(response);
        subscription.unsubscribe();
      }, error => {
        console.error(error);
        this._spinner.hideSpinner()
        this._exporting = false;
        this._userMessages.showSnackBarErrorMessage("אירעה שגיאה בייצוא הנתונים");
        subscription.unsubscribe();
      });
  }

  private _onBlobReceived(response: Blob) {
    const blob = new Blob([response], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = window.URL.createObjectURL(blob);
    const link = this._exportedFileLink.nativeElement;
    link.href = url;
    link.download = `${this.filename}.xlsx`;
    link.click();
    window.URL.revokeObjectURL(url);
  }

}
